export const MOBILE_BREAKPOINT = '(max-width: 759px)'
